/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-12-06 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function BannerIcon(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.70005 0H9.30005C9.7971 0 10.2 0.406299 10.2 0.907494V11.8328C10.2 11.9376 10.0768 11.9929 9.99964 11.9226L9.00106 11.0137C8.88687 10.9098 8.71323 10.9098 8.59903 11.0137L7.60106 11.9221C7.48687 12.026 7.31322 12.026 7.19904 11.9221L6.20106 11.0137C6.08687 10.9098 5.91322 10.9098 5.79904 11.0137L4.80106 11.9221C4.68687 12.026 4.51322 12.026 4.39904 11.9221L3.40106 11.0137C3.28687 10.9098 3.11323 10.9098 2.99904 11.0137L2.00045 11.9488C1.92327 12.019 1.80005 11.9638 1.80005 11.859V0.907494C1.80005 0.406299 2.20299 0 2.70005 0ZM4.50005 5.4C4.99711 5.4 5.40005 4.99706 5.40005 4.5C5.40005 4.00294 4.99711 3.6 4.50005 3.6C4.00299 3.6 3.60005 4.00294 3.60005 4.5C3.60005 4.99706 4.00299 5.4 4.50005 5.4ZM8.40005 7.5C8.40005 7.99706 7.9971 8.4 7.50005 8.4C7.00299 8.4 6.60005 7.99706 6.60005 7.5C6.60005 7.00294 7.00299 6.6 7.50005 6.6C7.9971 6.6 8.40005 7.00294 8.40005 7.5ZM8.22431 4.62426C8.45863 4.38995 8.45863 4.01005 8.22431 3.77574C7.99 3.54142 7.6101 3.54142 7.37578 3.77574L3.77578 7.37574C3.54147 7.61005 3.54147 7.98995 3.77578 8.22426C4.0101 8.45858 4.39 8.45858 4.62431 8.22426L8.22431 4.62426Z"
        fill="#8C9196"
      />
    </svg>
  );
}
export function BannerIconDisable(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.28571 2H14.7143C15.4244 2 16 2.54173 16 3.20999V17.777C16 17.9168 15.824 17.9905 15.7137 17.8968L14.2872 16.685C14.124 16.5464 13.876 16.5464 13.7128 16.685L12.2872 17.8961C12.124 18.0346 11.876 18.0346 11.7128 17.8961L10.2872 16.685C10.124 16.5464 9.87597 16.5464 9.71284 16.685L8.28716 17.8961C8.12403 18.0346 7.87597 18.0346 7.71284 17.8961L6.28716 16.685C6.12403 16.5464 5.87597 16.5464 5.71284 16.685L4.28629 17.9317C4.17603 18.0254 4 17.9517 4 17.812V3.20999C4 2.54173 4.57563 2 5.28571 2ZM7.85714 9.2C8.56722 9.2 9.14286 8.66274 9.14286 8C9.14286 7.33726 8.56722 6.8 7.85714 6.8C7.14706 6.8 6.57143 7.33726 6.57143 8C6.57143 8.66274 7.14706 9.2 7.85714 9.2ZM13.4286 12C13.4286 12.6627 12.8529 13.2 12.1429 13.2C11.4328 13.2 10.8571 12.6627 10.8571 12C10.8571 11.3373 11.4328 10.8 12.1429 10.8C12.8529 10.8 13.4286 11.3373 13.4286 12ZM13.1775 8.16569C13.5123 7.85327 13.5123 7.34673 13.1775 7.03431C12.8428 6.7219 12.3001 6.7219 11.9653 7.03431L6.82248 11.8343C6.48774 12.1467 6.48774 12.6533 6.82248 12.9657C7.15721 13.2781 7.69993 13.2781 8.03466 12.9657L13.1775 8.16569Z"
        fill="#5C5F62"
      />
    </svg>
  );
}
